import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const analytics = getAnalytics();
// export const firebaseAnalytics = firebase.analytics;

const ggprovider = new firebase.auth.GoogleAuthProvider();
ggprovider.setCustomParameters({ prompt: 'select_account' });

const fbProvider = new firebase.auth.FacebookAuthProvider();

export const signInWithGoogle = () => auth.signInWithPopup(ggprovider);
export const signInWithFacebook = () => auth.signInWithPopup(fbProvider);

export default firebase;
